import { takeUntil } from 'rxjs/operators';
import { UnsubscribeOnDestroy } from 'src/app/_helpers/unsubscribe-on-destroy';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Contenido, Envios } from 'src/app/model/notificadetalles';
import { NotificationService } from 'src/app/_services/notification.service';
import { ListadoTramitesEmvsService } from 'src/app/listado/listado-tramites-emvs/listado-tramites-emvs.service';
import { NotificationI18nService } from '../../core/util/notification-i18n.service';

@Component({
  selector: 'app-comunicacion-detalles',
  templateUrl: './comunicacion-detalles.component.html',
  styleUrls: ['./comunicacion-detalles.component.scss']
})
export class ComunicacionDetallesComponent  extends UnsubscribeOnDestroy{

  @Input() display?: string ='none';
  @Input() notificacionActivada?:Envios;
  @Output() displayOut = new EventEmitter<string>();
  loading:boolean=false;

  constructor(
    private _download:ListadoTramitesEmvsService,
    private notificationI18n: NotificationI18nService,
    ){
    super();
  }

  close() {
    this.displayOut.emit('none');
  }

  downloadArchivo(contenido: Contenido){
    this.loading=true;

    this._download.downloadB64(contenido.id_gestor_documental)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
      next:(fichero) => {
        
        const linkSource = `data:${contenido.nombre_formato};base64,` + fichero.Result;
        const downloadLink = document.createElement("a");
        const fileName = contenido.nombre_documento;

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        this.loading=false;
        this.close();
      },
      error:(error) => {
        console.error(error);
        this.loading=false;
        this.notificationI18n.error('NOTIFICATION.MESSAGE.NO_SE_PUDO_DESCARGAR_EL_DOCUMENTO');
      }
    });
  }

  formatDate(date: any[]) {
    let month = (date[1]<10)?'0'+date[1]:date[1];
    let day   = (date[2]<10)?'0'+date[2]:date[2];
    let year  = date[0];
    let hour  = (date[3]<10)?'0'+date[3]:date[3];
    let min   = (date[4]<10)?'0'+date[4]:date[4];
    let seg   = (date[5]<10)?'0'+date[5]:date[5];
    return [day, month, year].join('/').concat(' '+[hour, min, seg].join(':'));
  }
}
